export const buildVersion = '2026.11.04.0750';
export const manifestVersion = '2026.11.04.0750';
